import { m } from '@sohanscript/i18n';
import { SohanScriptLoader } from '@sohanscript/ui/sohanscript-loader';
import { ClientOnly, useNavigate, useRouter } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Button } from './ui/button';

const NotFoundLottie = lazy(() =>
	import('@sohanscript/ui/animated/404-lottie').then((module) => ({
		default: module.NotFoundLottie,
	})),
);

export function ErrorComponent({
	message,
	action,
}: {
	message: string;
	action?: React.ReactNode;
}) {
	const navigate = useNavigate();
	const router = useRouter();

	const goBack = () => {
		try {
			const referrer = new URL(document.referrer);
			if (referrer.origin === window.location.origin) {
				router.history.back();
				return;
			}
		} catch {}
		navigate({ to: '/' });
	};

	return (
		<section className="grid min-h-safe-screen place-content-center gap-4">
			<p className="translate-y-15 text-center font-bold font-matrix text-2xl text-primary/80">
				{message}
			</p>
			<ClientOnly
				fallback={
					<center className="h-54 grid place-content-center">
						<SohanScriptLoader className="size-26" />
					</center>
				}
			>
				<Suspense fallback={<SohanScriptLoader className="size-26" />}>
					<NotFoundLottie />
				</Suspense>
			</ClientOnly>
			<div className="flex items-center justify-center gap-4">
				<Button
					icon="lucide:chevron-left"
					variant="hover"
					onClick={goBack}
					className="rtl:rotate-180"
				>
					{m.error_go_back()}
				</Button>
				{action || (
					<Button icon="lucide:home" href="/">
						{m.error_home()}
					</Button>
				)}
			</div>
		</section>
	);
}
